import { Button } from "V2.0/common/button";
import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Components/ConfigurationPanel";
import NodeExecutionStatusBadge from "../../../Components/NodeExecutionStatus";
import { formatTime } from "V2.0/utils";
import PreviewJson from "../../../Components/PreviewJson";
import TabsWithPills from "V2.0/common/tabsWithPills";
import { useEffect, useState } from "react";
import Conversation, { useConversation } from "../Components/Conversation";

export default VoiceCallActionExecution;

function VoiceCallActionExecution(props) {
  const { node, nodeExecution, closePanel, workspaceId } = props;

  const [activeTab, setActiveTab] = useState("Execution");
  const { conversation, loading, fetchConversation } = useConversation();

  useEffect(() => {
    if (workspaceId && nodeExecution?.output?.conversationId) {
      fetchConversation(workspaceId, nodeExecution.output.conversationId);
    }
  }, [workspaceId, nodeExecution?.output?.conversationId]);

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <div className="flex flex-col gap-y-2">
          <p>{node.data.name}</p>
          <TabsWithPills
            tabs={[
              {
                name: "Execution",
                current: activeTab === "Execution",
                href: "#",
              },
              {
                name: "Conversation",
                current: activeTab === "Conversation",
                href: "#",
              },
            ]}
            onTabChange={(e, { tab }) => setActiveTab(tab.name)}
          />
        </div>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        {activeTab === "Execution" && (
          <div className="space-y-4">
            <div className="flex items-center gap-x-2">
              <p className="text-sm">Status:</p>
              <NodeExecutionStatusBadge status={nodeExecution.status} />
            </div>
            {nodeExecution.startTime && <div className="flex items-center gap-x-2">
              <p className="text-sm">Start Time:</p>
              <p className="text-sm">{formatTime(nodeExecution.startTime)}</p>
            </div>}
            {nodeExecution.endTime && <div className="flex items-center gap-x-2">
              <p className="text-sm">End Time:</p>
              <p className="text-sm">{formatTime(nodeExecution.endTime)}</p>
            </div>}
            {nodeExecution.input && <PreviewJson
              title="Input"
              data={nodeExecution.input}
            />}
            {nodeExecution.output && <PreviewJson
              title="Output"
              data={nodeExecution.output}
            />}
          </div>
        )}
        {activeTab === "Conversation" && conversation && (
          <Conversation conversation={conversation} />
        )}
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end gap-x-2 items-center">
          <Button
            outline
            onClick={closePanel}
          >
            Close
          </Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
